<template>
  <div class="container">
    <div class="row flex-wrap gutter-sm">
      <component
        :is="cardComponent"
        v-for="card in [featuredEvent]"
        :key="card.id"
        :blok="card"
        card-type="featured"
        class="xs-12 sm-12"
      />
    </div>
    <div class="row flex-wrap row--no-bottom gutter-sm">
      <component
        :is="cardComponent"
        v-for="card in events"
        :key="card.id"
        :blok="card"
        card-type="horizontal"
        class="xs-12 sm-6"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { EventsStoryblok } from '~/types/storyblok'

const props = defineProps<{
  blok: EventsStoryblok[]
  contentType: string
}>()

const cardComponent = computed(() =>
  slugToComponentTypeName(props.contentType, 'Card'),
)

const featuredEvent = computed(() => props.blok?.[0])
const events = computed(() => props.blok?.slice(1))
</script>

<style lang="less" scoped>
// stuff
</style>
